import { forwardRef, InputHTMLAttributes, RefObject } from 'react';
import styled from 'styled-components';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  inputRef?: RefObject<HTMLInputElement>;
}

const Input = styled('input')`
  width: ${({ width }) => (width ? width : '100%')};
  height: 56px;
  border: 1px solid;
  border-color: ${(props: any) => (props['data-error'] ? props.theme.colors.alert_400 : props.theme.colors.gray_300)};
  border-radius: 4px;
  padding: 8px 10px;
  outline: none;
  background: white;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'inherit')};
  color: ${({ theme, disabled, ...props }: any) =>
    disabled ? theme.colors.black50 : props['data-error'] ? theme.colors.alert_400 : theme.colors.dark_350};
  -webkit-user-select: text;

  &[data-com-onepassword-filled='light'] {
    background-color: red !important;
  }

  ${(props: any) => {
    return props['data-removearrows']
      ? `
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        -moz-appearance: textfield;
      }
    `
      : ``;
  }}

  ${({ theme: { mediaQueries, fontSizes } }) => {
    return `
      font-size: ${fontSizes[0]};

      ${mediaQueries.desktop} {
        font-size: ${fontSizes[1]};
      }
    `;
  }}

  &::-webkit-input-placeholder {
    /* Edge */
    font-size: ${({ theme }) => theme.fontSizes[0]};
    color: ${({ theme }) => theme.colors.black30};
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-size: ${({ theme }) => theme.fontSizes[0]};
    color: ${({ theme }) => theme.colors.black30};
  }

  &::placeholder {
    font-size: ${({ theme }) => theme.fontSizes[0]};
    color: ${({ theme }) => theme.colors.black30};
  }
`;

const InputTag = forwardRef<HTMLInputElement, InputProps>(({ children, inputRef, ...props }, ref) => <Input {...props} ref={inputRef || ref} />);

export default InputTag;
